import { Link } from "react-router-dom";
import styled from "styled-components";
const BranchLink = styled.button`
    background-color: ${(props) => props.activeColor || "white"};
    border-radius: 10px;
    padding: 10px 20px;
    margin: 5px;
    color: ${(props) =>
      props.activeColor ? "white" : "rgba(138, 94, 191, 1)"};
    border: ${(props) =>
      props.activeColor ? "" : "dashed 2px rgba(138, 94, 191, 1)"};
    text-decoration: none;
    
    &:hover {
      color: ${(props) =>
      props.activeColor ? "white" : "rgba(138, 94, 191, 1)"};
    }
  `;
  export default BranchLink;